import { PageSections } from '@moar/ui';
import { GetStaticProps } from 'next';
import { PageSectionsIndexProps } from '@moar/types';
import { fetchTimeline } from '@moar/data';
const apiUrl = process.env['NEXT_PUBLIC_API_URL_TIMELINE_AMREV'] || '';
const apiUrlPreview = process.env['NEXT_PUBLIC_API_URL_TIMELINE_AMREV_PREVIEW'] || '';

export const getStaticProps: GetStaticProps = async ({ params = {}, preview = false }) => {
    const data = await fetchTimeline({
        apiUrl: preview ? apiUrlPreview : apiUrl,
        isProduction: process.env.NODE_ENV === 'production',
    });

    return {
        props: {
            timelineTitle: data.title,
            sections: data.timelineSections.data,
            preview,
            offlineAlertBanner: data.misc.offlineAlertBanner,
            seo: data.seo,
            aboutPageTitle: data.about.aboutPageTitle,
            howToPageTitle: data['how-to'].howToPageTitle,
            glossaryPageTitle: data.glossary.glossaryPageTitle,
            glossaryItemsCount: data.timelineGlossary.data.length,
        },
    };
};

export function SectionsIndex(props: PageSectionsIndexProps) {
    return <PageSections {...props} />;
}

export default SectionsIndex;
